export const SET_IS_PREVIEW_MODE = 'SET_IS_PREVIEW_MODE'
